import { render, staticRenderFns } from "./AssignShipmentModal.vue?vue&type=template&id=53e7e2c5&scoped=true&"
import script from "./AssignShipmentModal.vue?vue&type=script&lang=js&"
export * from "./AssignShipmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignShipmentModal.vue?vue&type=style&index=0&id=53e7e2c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e7e2c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e7e2c5')) {
      api.createRecord('53e7e2c5', component.options)
    } else {
      api.reload('53e7e2c5', component.options)
    }
    module.hot.accept("./AssignShipmentModal.vue?vue&type=template&id=53e7e2c5&scoped=true&", function () {
      api.rerender('53e7e2c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/components/AssignShipmentModal.vue"
export default component.exports